import {Service, signal} from '@angular/core'

@Service()

export class ConfigService {
  public site = signal<string>('assets/sparguide-test.html')
}
